<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      {{language=='es'?"Español":'中文'}}
      <i class="el-icon-arrow-down el-icon--right"></i>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :disabled="language==='zh'" command="zh">中文</el-dropdown-item>
      <!-- <el-dropdown-item :disabled="language==='en'" command="en">English</el-dropdown-item> -->
       <el-dropdown-item :disabled="language==='es'" command="es">
        Español
      </el-dropdown-item>
     <!-- <el-dropdown-item :disabled="language==='ja'" command="ja">
        日本語
      </el-dropdown-item>-->
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { setLanguage,getLanguage } from "@/utils/storage.js";
import Cookies from 'js-cookie'
export default {
  computed: {
    language() {
      var language=getLanguage()
      Cookies.set('language',language)
      return language;
    }
  },
  methods: {
    handleSetLanguage(lang) {
      // 必须先持久化语言设置，再刷新页面，否则刷新后 i18n 读取不到新值
      Cookies.set('language', lang);
      setLanguage(lang);
      this.$i18n.locale = lang;
      this.$router.go(0);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/LangSelect/index.vue